import React, { useMemo } from "react";
import { Box, Grid, Typography } from "@material-ui/core";
import { AccountSearchCriteria, AccountStatus } from "../../../api/services";
import { InlineType } from "../../../components/InlineType";
import { ElectricityIcon, GasIcon } from "../../../icons";

interface SearchCriteriaProps {
  status: AccountStatus;
}

export const SearchCriteria: React.FC<
  AccountSearchCriteria & SearchCriteriaProps
> = ({ phone, email, mpan, mprn, status }) => {
  const [title, value, icon] = useMemo(() => {
    if (mpan) return ["MPAN", mpan, <ElectricityIcon height={16} width={16} />];
    if (mprn) return ["MPRN", mprn, <GasIcon height={16} width={16} />];
    if (phone) return ["Phone", phone, null];
    if (email) return ["Email", email, null];
    return [null, null];
  }, [phone, email, mpan, mprn]);

  if (!title || !value) return null;
  const isCancelled = status === "Cancelled";

  return (
    <>
      <Box mt={1} data-testid="SearchCriteria__Title" display="inline-block">
        <InlineType textDecoration="none">
          <Typography variant="caption" color="textSecondary">
            {title}
          </Typography>
        </InlineType>
      </Box>
      <Box lineHeight={1} clone data-testid="SearchCriteria__Content">
        <Grid container alignItems="center">
          {icon && <Grid item>{icon}</Grid>}
          <Grid item>
            <Typography
              variant="body2"
              color={isCancelled ? "textSecondary" : "textPrimary"}
            >
              <InlineType fontWeight={700}>{value}</InlineType>
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
